import styled, { css } from 'styled-components';
import { COLOR_SYSTEM } from 'components/atoms';

export const DetailContainer = styled.div`
  padding: 8px 0;
`;

// D3(2026-10-15): padding-right·word-break는 K-MRS판 제목에만. 늘품판·기본판은 rel 07059b9 스타일 그대로.
export const DetailTitle = styled.h3<{ $kmrs?: boolean }>`
  font-size: 16px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get('Gray')?.[800]};
  margin: 0 0 16px 0;
  ${({ $kmrs }) =>
    $kmrs &&
    css`
      /* K-MRS판 전용: 긴 제공받는 자 이름이 시트 닫기(×) 버튼(absolute, top/right 12px · 지름 40px)을
         덮지 않도록 그 폭만큼 오른쪽을 비우고, 버튼 앞에서 단어 단위로 줄바꿈한다. */
      padding-right: 48px;
      word-break: keep-all;
    `}
`;

export const DetailTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  line-height: 1.6;
`;

export const DetailRow = styled.tr`
  border-bottom: 1px solid ${COLOR_SYSTEM.get('Gray')?.[100]};

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.td`
  width: 90px;
  min-width: 90px;
  padding: 12px 8px;
  font-weight: 600;
  color: ${COLOR_SYSTEM.get('Gray')?.[700]};
  vertical-align: top;
  background: ${COLOR_SYSTEM.get('Gray')?.[25]};
`;

export const DetailValue = styled.td`
  padding: 12px 8px;
  color: ${COLOR_SYSTEM.get('Gray')?.[600]};
  word-break: keep-all;
  overflow-wrap: anywhere;

  ul {
    margin: 0;
    padding-left: 16px;
  }

  li {
    margin-bottom: 4px;
  }

  strong {
    color: ${COLOR_SYSTEM.get('Gray')?.[700]};
  }

  .note {
    margin-top: 6px;
    font-size: 12px;
    color: ${COLOR_SYSTEM.get('Gray')?.[400]};
  }
`;
